import './SkeletonBox-cde41765.css';

var classes = {"SkeletonBox":"prc-Skeleton-SkeletonBox-HR9PH","shimmer":"prc-Skeleton-shimmer-ngQtR"};

export { classes as default };
